import { helpers } from "@vuelidate/validators";

const organizationNumberValidation = /^[0-9]{6}-?[0-9]{4}$/;

export default {
  organizationNumber: {
    format: helpers.regex(organizationNumberValidation),
  },
};
